module.exports = __webpack_public_path__ + "static/media/app_bar_texture.be4277ef.png";